import React, { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import { getFilterCompetitorsFormEntities } from '@app/utils/entitiesAdapters/getFilterCompetitorsFormEntities'
import { cloneDeep } from '@app/utils/cloneDeep'
import { RendererWrapper } from '@app/components/renderers'
import { LntSelect } from '@app/components/base'
import { SEPARATOR } from '@app/constants/separator'

import { SIZE } from '@app/constants'
import { LOCATION_KEY } from '@app/constants/queryKeys'

import { getCompetitors } from '@app/api/routes/locationCompetitors'

import type { Column } from '@app/components/base/Table/types'
import type { TotalMonitoringDataSource } from '@app/pages/MonitoringLaunchPage/Tabs/TotalMonitoringTab/types'
import type { UseCompetitorsColumnParams } from './types'

export const useCompetitorsEditableColumn = ({
  columns,
  patchCreatingTasks
}: UseCompetitorsColumnParams): Array<Column<TotalMonitoringDataSource>> => {
  const [columnsWithCompetitors, setColumnsWithCompetitors] = useState(columns)

  const { data: competitorsData } = useQuery({
    queryKey: [LOCATION_KEY.locationCompetitorsItems],
    queryFn: async () => await getCompetitors()
  })

  useEffect(() => {
    const competitorColumn = columns.find(column => column.key === 'competitors')

    if (competitorColumn) {
      competitorColumn.render = (_, { competitors, runParametersId }) => {
        const competitorIds = competitors?.map(competitor => competitor.id) ?? []
        const options = getFilterCompetitorsFormEntities(competitorsData)

        return (
          <RendererWrapper minWidth={ 314 }>
            <LntSelect
              value={ competitorIds }
              options={ options }
              loading={ !competitorsData }
              disabled={ !competitorsData }
              onChange={ (newCompetitorIds: string[]) => {
                patchCreatingTasks(newCompetitorIds, [runParametersId])
              } }
              size={ SIZE.small }
              mode='multiple'
              strictValue
              showArrow
              tokenSeparators={ [SEPARATOR.newline] }
            />
          </RendererWrapper>
        )
      }

      setColumnsWithCompetitors(cloneDeep(columns))
    }
  }, [columns, competitorsData])

  return columnsWithCompetitors
}
